var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_copy",
    clipPath: "url(#clip0_2_11975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.66667 1.94141H2.33333C1.6 1.94141 1 2.54141 1 3.27474V11.9414C1 12.3081 1.3 12.6081 1.66667 12.6081C2.03333 12.6081 2.33333 12.3081 2.33333 11.9414V3.94141C2.33333 3.57474 2.63333 3.27474 3 3.27474H9.66667C10.0333 3.27474 10.3333 2.97474 10.3333 2.60807C10.3333 2.24141 10.0333 1.94141 9.66667 1.94141ZM10.06 5.00141L13.28 8.22141C13.5267 8.46807 13.6667 8.80807 13.6667 9.16141V15.2747C13.6667 16.0081 13.0667 16.6081 12.3333 16.6081H4.99333C4.26 16.6081 3.66667 16.0081 3.66667 15.2747L3.67333 5.94141C3.67333 5.20807 4.26667 4.60807 5 4.60807H9.11333C9.46667 4.60807 9.80667 4.74807 10.06 5.00141ZM9.66667 9.27474H12.6667L9 5.60807V8.60807C9 8.97474 9.3 9.27474 9.66667 9.27474Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_11975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.941406)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3d4ea98dfc1c3009520d623048b516e1.svg";
export { ForwardRef as ReactComponent };